import http from '@/libs/axios'

export function getPtoForGood(params) {
  return http.get('/pto/pto_for_good/', { params })
}

export function getPtoForGoodOne(id) {
  return http.get(`/pto/pto_for_good/${id}`,)
}

export function createPtoForGood(data) {
  return http.post('/pto/pto_for_good/', data)
}

export function updatePtoForGood(data) {
  return http.patch(`/pto/pto_for_good/${data.id}`, data)
}

export function deletePtoForGood(id) {
  return http.delete(`/pto/pto_for_good/${id}/`)
}

export function deletePtoForGoodImages(id) {
  return http.delete(`/files/attachments/${id}/`)
}

export function getExcelFileReportOne(id) {
  return http({
    url: `/pto/report/${id}/excel/`,
    method: 'GET',
    responseType: 'blob'
  })
}
